import Button from '@shared/components/buttons';
import HyperlinkButton from '@shared/components/buttons/hyperlink-button';
import InputGroup from '@shared/components/forms/form-components/inputs/input-group';
import TextInput from '@shared/components/forms/form-components/inputs/text-input';
import { Icon, IconNames } from '@shared/components/icons';
import { html } from '@shared/utils/rendering/html';
import { getConfig } from '../../../../config';

const baseURL = (await getConfig()).RDARR_APP_URL;

const FileDownload = ({ inputProps, layoutSettings }) => {
    return html`
        <div class="${layoutSettings.column}">
            <div class="form-group ${layoutSettings.formGroup}">
                <${InputGroup}
                    label=${inputProps.label}
                    input=${html`<${TextInput}
                            disabled
                            ...${inputProps}
                            label=${{ include: false }}
                            field=${{
                                ...inputProps?.field,
                                value: inputProps?.field?.value?.fileName,
                            }}
                        />
                        <${HyperlinkButton}
                            label=${{
                                text: 'Download',
                                precedent: html`<${Icon} name=${IconNames.Download} />`,
                            }}
                            href="${baseURL}/${inputProps?.field?.value?.fileUrl ?? '#'}"
                            target="_blank"
                            style="pointer-events: auto !important; cursor: pointer;"
                        />`}
                />
            </div>
        </div>
    `;
};

export default FileDownload;
